<template>
  <section
    v-show="cms.event_id"
    v-editable="cms"
    :class="[name]"
    :style="mainCssVars"
  >
    <grid :class="['grid--container', `${name}__grid`]">
      <grid-item :class="`${name}__grid-item`">
        <div :id="`eventbrite-widget-container-${cms.event_id}`" />
        <div v-if="!isHttps && inEditor">
          <a-eyebrow :cms="{ eyebrow: 'Notice' }" :class="`${name}__eyebrow`" />
          <a-heading
            :cms="{
              heading: `This Eventbrite widget will only work over https.`,
            }"
            :class="`${name}__heading`"
          />
          <!-- eslint-disable vue/no-v-html -->
          <div
            :class="`${name}__text`"
            v-html="
              $options.filters.markdown(
                'Due to the way <a href=\'https://www.eventbrite.co.uk/\' target=\'_blank\'>Eventbrite</a> works, their widget will only display over HTTPS (ie on Live). ' +
                  'This means that whilst editing on Staging by default the component will be limited to displaying this message and some basic information.'
              )
            "
          />
          <pre>
            Event ID: {{ cms.event_id }}
            Widget Type: {{ cms.widget_type }}
            iframe Container ID: {{
              `eventbrite-widget-container-${cms.event_id}`
            }}
          </pre>
        </div>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import data from '~/components/organisms/o-eventbrite-widget/o-eventbrite-widget.data'
import Colors from '~/mixins/colors'

export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return process.env.NODE_ENV === 'development' ? { ...data } : {}
      },
    },
  },

  data() {
    return {
      name: 'o-eventbrite-widget',
      show: false,
      host: '',
    }
  },

  computed: {
    ...mapGetters({
      inEditor: 'globals/getInEditor',
    }),
    isHttps() {
      return this.host.match(/^https:\/\//g)
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
  },

  mounted() {
    this.host = window.location.origin

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://www.eventbrite.co.uk/static/widgets/eb_widgets.js'
    document.body.appendChild(script)

    if (window.EBWidgets) {
      console.log({
        // Required
        widgetType: 'checkout',
        eventId: this.cms.event_id,
        iframeContainerId: `eventbrite-widget-container-${this.cms.event_id}`,
      })
      window.EBWidgets.createWidget({
        // Required
        widgetType: 'checkout',
        eventId: this.cms.event_id,
        iframeContainerId: `eventbrite-widget-container-${this.cms.event_id}`,
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-hero-text-block {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: var(--spacing-top) 0 var(--spacing-bottom);

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  .grid {
    align-content: center;
  }
}
</style>
